import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import StudentsDashboard from "../dashboards/StudentsDashboard";
import AdminDashboard from "../dashboards/AdminDashboard";
import AdminNavBar from "../components/AdminNavbar";
import { AdminSidebar } from "../components/AdminSideBar";
import StaffDashboard from "../dashboards/StaffDashboard";
import HODDashboard from "../dashboards/HODDashboard";

const Dashboard = () => {
  const [userRole, setUserRole] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
    } else {
      const decoded = jwtDecode(token);
      setUserRole(decoded.role);
    }
  }, [navigate]);

  return (
    <div className="dashboard">
      {/* <h2>Dashboard</h2> */}
      {userRole === "admin" && (
        <div style={{ marginTop: "-120px", width: "100%" }}>
          <AdminNavBar />
          {/* <AdminSidebar /> */}
          <AdminDashboard />
        </div>
      )}

      {userRole === "staff" && (
        <div style={{ marginTop: "-120px", width: "100%" }}>
          <StaffDashboard />
        </div>
      )}
      {userRole === "student" && (
        <>
          <div>
            <StudentsDashboard />
          </div>
        </>
      )}
      {userRole === "hod" && (
        <>
          <div>
            <HODDashboard />
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
